import { render, staticRenderFns } from "./TestReportScoreDist.vue?vue&type=template&id=c9776c22&"
import script from "./TestReportScoreDist.vue?vue&type=script&lang=ts&"
export * from "./TestReportScoreDist.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports